/**
 * Format a cents value as a currency string (e.g. 1500 -> "$15.00").
 * Mirrors the server-side format_money() helper.
 */
export function formatMoney(cents) {
  return `$${(cents / 100).toFixed(2)}`
}

/**
 * Format a cents value as a decimal string for input fields (e.g. 1500 -> "15.00").
 */
export function centsToDecimal(cents) {
  return (cents / 100).toFixed(2)
}
